import { render, staticRenderFns } from "./NewFileRequestDialogDatePassword.vue?vue&type=template&id=2a450f9e&scoped=true"
import script from "./NewFileRequestDialogDatePassword.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialogDatePassword.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialogDatePassword.vue?vue&type=style&index=0&id=2a450f9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a450f9e",
  null
  
)

export default component.exports